import script from "./SummaryResult.vue?vue&type=script&setup=true&lang=js"
export * from "./SummaryResult.vue?vue&type=script&setup=true&lang=js"

import "./SummaryResult.vue?vue&type=style&index=0&id=212d7be1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-212d7be1"]])

export default __exports__